import { render, staticRenderFns } from "./TabExtraWork.vue?vue&type=template&id=2b7d6018"
import script from "./TabExtraWork.vue?vue&type=script&setup=true&lang=js"
export * from "./TabExtraWork.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports